import schedulingContextAtom from "@/atoms/scheduling-context"
import { tableAtom } from "@/atoms/table"
import {
  resolveStorefrontScheduling,
  type StorefrontScheduling,
} from "@/lib/scheduling/storefront-state"
import { useAtomValue } from "jotai"
import { useMemo } from "react"

const TABLE_MODE: StorefrontScheduling = {
  known: false,
  bagUnlocked: true,
  block: null,
  banner: null,
  catalogWindow: null,
  instantChannels: [],
  schedulableChannels: [],
  timingStepVisible: false,
  implicitTiming: "INSTANT",
  futureWindows: false,
  timezone: null,
}

/**
 * The scheduling state table (§2A.5) for the storefront the customer is
 * browsing. Dine-in never schedules, so table mode short-circuits to the
 * pre-scheduling behaviour.
 */
export function useStorefrontScheduling(): StorefrontScheduling {
  const context = useAtomValue(schedulingContextAtom)
  const table = useAtomValue(tableAtom)

  return useMemo(() => {
    if (table) return TABLE_MODE
    return resolveStorefrontScheduling(context)
  }, [context, table])
}
